import React, { useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import Datagrid from "../Components/Datagrid";
import DatagridContext from "../Context/datagridContext";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import toolbar from "../Config/toolbarConfig";
import editSettings from "../Config/editSettingsConfig";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const UsersPage = () => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [status, setStatus] = useState(null);

  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  useTitle(`${t("Users")} | Netileti`);

  const getData = async () => {
    setUrl(`${baseUrl}/users`);
    setFrom("Users");
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [status]);

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "emailConfirmed",
      headerText: "emailConfirmed",
      allowEditing: false,
      isPrimaryKey: false,
      visible: false,
    },
    {
      field: "userName",
      headerText: t("User Name"),
      allowEditing: true,
      validationRules: { required: true },
    },
    {
      field: "email",
      headerText: t("Email"),
      allowEditing: true,
      validationRules: { required: true },
      template: ({ email, emailConfirmed }) => (
        <>
          {email}
          <span
            className={
              emailConfirmed
                ? "e-icons e-small e-check chips chips-true"
                : "e-icons e-small e-close chips chips-false"
            }
            style={{ color: "white" }}
          />
        </>
      ),
    },
    {
      field: "role",
      headerText: t("Role"),
    },
    {
      field: "wabaid",
      headerText: t("Waba ID"),
      allowEditing: true,
    },
    {
      field: "",
      headerText: "",
      allowEditing: false,
      textAlign: "center",
      width: "15%",
      template: ({ id }) => (
        <button
          onClick={() => navigate(`/users/${id}`)}
          className="e-btn e-primary e-outline e-small"
        >
          {t("Licences")}
        </button>
      ),
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"

    >
      <div       style={{ display: "flex", justifyContent: "center", height: "auto" }}>
        {status === 401 ? (
          <UnauthorizePage />
        ) : status === 403 ? (
          <ForbiddenPage />
        ) : (
          <DatagridContext.Provider
            value={{
              editSettings,
              toolbar: toolbar("CRUD"),
              url,
              from,
              setStatus,
            }}
          >
            <Datagrid columns={columns} />
          </DatagridContext.Provider>
        )}
      </div>
    </div>
  );
};

export default UsersPage;
